<template>
    <div id="dropdown-list-settings">
        <div class="form-field">
            <label for="field-label" class="form-label">{{ $t("form.fieldLabel") }}</label>
            <input
                type="text"
                id="field-label"
                class="form-input"
                placeholder="Bir soru girin"
                v-model="fieldLabel"
                @input="setFieldLabel(fieldLabel)"
            >
        </div>
        <div class="form-field">
            <label for="field-label" class="form-label">{{ $t("form.placeholder") }}</label>
            <input
                type="text"
                id="field-label"
                class="form-input"
                :placeholder="$t('form.pleaseSelect')"
                v-model="placeholder"
                @input="setplaceholder(placeholder)"
            >
        </div>

        <div class="form-field">
            <label class="form-label">{{ $t("form.labelAlignment") }}</label>
            <div class="button-group">
                <button class="button" :class="{ active: labelAlign === 'left' }" @click="setLabelAlign('left')">{{ $t("form.left") }}</button>
                <button class="button" :class="{ active: labelAlign === 'right' }" @click="setLabelAlign('right')">{{ $t("form.right") }}</button>
                <button class="button" :class="{ active: labelAlign === 'top' }" @click="setLabelAlign('top')">{{ $t("form.top") }}</button>
            </div>
            <small class="form-description">{{ $t("form.chooseLabelAlignment") }}</small>
        </div>

        <div class="form-field">
            <label class="form-label">{{ $t("form.required") }}</label>
            <div class="toggle">
                <span class="toggle-option" :class="{ active: isRequired }" @click="toggleRequired">{{ isRequired ? $t('chatWindow.open') : $t('chatWindow.closed') }}</span>
            </div>
            <small class="form-description">{{ $t("form.fieldEmptyError") }}</small>
        </div>

        <div class="form-field">
            <label class="form-label">Görünürlük</label>
            <div class="toggle">
                <span class="toggle-option" :class="{ active: visibility }"
                      @click="toggleVisibility">{{ visibility ? "Görünür" : "Gizli" }}</span>
            </div>
            <small class="form-description">Bu alanın form üzerinde görünür olup olmayacağını belirler</small>
        </div>

        <div class="form-field">
            <label for="slug-input" class="form-label">URL Parametresi</label>
            <input
                type="text"
                id="slug-input"
                class="form-input"
                placeholder="dropDownList"
                v-model="slug"
                @input="setSlug($event.target.value)"
            >
            <small class="form-description">URL parametrelerinde kullanılacak benzersiz tanımlayıcı</small>
        </div>

        <div class="form-field">
            <label class="form-label">{{ $t("form.subLabels") }}</label>
            <input
                type="text"
                class="form-input"
                :placeholder="$t('form.addDescriptionBelowField')"
                v-model="altLabel"
                @input="setAltLabel(altLabel)"
            >
        </div>

        <!--        <div class="form-field">-->
        <!--            <label class="form-label">Alanı Kopyala</label>-->
        <!--            <button class="duplicate-button" @click="duplicateField">DUPLICATE</button>-->
        <!--            <small class="form-description">Bu alanın tüm kayıtlı ayarlarını koruyarak bir kopyasını oluşturun</small>-->
        <!--        </div>-->
    </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
    name: 'DropDownListSettings',
    props: {
        item: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            fieldLabel: this.item.dropDownList.fieldLabel,
            placeholder: this.item.dropDownList.placeholder,
            labelAlign: this.item.dropDownList.align,
            defaultAlign: this.item.dropDownList.defaultAlign,
            isRequired: this.item.dropDownList.isRequired || false,
            altLabel: this.item.dropDownList.altLabel,
            items: this.item.dropDownList.items,
            visibility: this.item.visibility !== undefined ? this.item.visibility : true,
            slug: this.item.slug || '',
            updateTimer: null,
        };
    },
    methods: {
        ...mapActions("forms", ["updateFormField"]),
        setLabelAlign(align) {
            this.labelAlign = align;
            this.$emit("update-label-align-drop-down-list", align);
            this.updateField();
        },
        toggleRequired() {
            this.isRequired = !this.isRequired;
            this.updateField();
            this.$emit('update-required', this.isRequired);
        },
        setFieldLabel(label) {
            this.$emit("update-field-label-drop-down-list", label);
            this.updateField();
        },
        setplaceholder(placeholder) {
            this.$emit("update-placeholder-drop-down-list", placeholder);
            this.updateField();
        },
        setAltLabel(label) {
            this.$emit("update-alt-label-drop-down-list", label);
            this.updateField();
        },
        toggleVisibility() {
            this.visibility = !this.visibility;
            this.updateField();
            this.$emit('update-visibility', this.visibility);
        },
        setSlug(slug) {
            this.slug = this.sanitizeSlug(slug);
            this.updateField();
        },
        sanitizeSlug(slug) {
            if (!slug) return '';

            return slug
                .replace(/ğ/gim, "g")
                .replace(/ü/gim, "u")
                .replace(/ş/gim, "s")
                .replace(/ı/gim, "i")
                .replace(/ö/gim, "o")
                .replace(/ç/gim, "c")
                .replace(/[^a-z0-9-]/gim, "-")
                .replace(/-+/gim, "-")
                .replace(/^-|-$/gim, "")
                .toLowerCase();
        },
        updateField() {
            let self = this;
            if (this.updateTimer) {
                clearTimeout(this.updateTimer);
            }
            this.updateTimer = setTimeout(function () {
                const updateFields = {
                    visibility: self.visibility,
                    slug: self.slug,
                    dropDownList: {
                        fieldLabel: self.fieldLabel,
                        placeholder: self.placeholder,
                        align: self.labelAlign,
                        defaultAlign: self.defaultAlign,
                        isRequired: self.isRequired,
                        altLabel: self.altLabel,
                        items: self.items,
                    },
                };
                self.updateFormField({
                    siteId: self.item.siteId,
                    formFieldId: self.item._id,
                    updateFields: updateFields,
                }).catch(function (error) {
                    console.error("Error updating form field:", error);
                });
            }, 800);
        },
    },
    watch: {
        item: {
            handler: function (val) {
                if (!val || !val.dropDownList) { return; }
                this.fieldLabel = val.dropDownList.fieldLabel;
                this.placeholder = val.dropDownList.placeholder;
                this.labelAlign = val.dropDownList.align;
                this.defaultAlign = val.dropDownList.defaultAlign;
                this.isRequired = !!val.dropDownList.isRequired;
                this.altLabel = val.dropDownList.altLabel;
                this.items = val.dropDownList.items || [];
                this.visibility = typeof val.visibility !== 'undefined' ? val.visibility : this.visibility;
                this.slug = val.slug || '';
            },
            deep: true,
            immediate: false,
        },
        'item.dropDownList.fieldLabel': function (v) { this.fieldLabel = v; },
        'item.dropDownList.placeholder': function (v) { this.placeholder = v; },
        'item.dropDownList.align': function (v) { this.labelAlign = v; },
        'item.dropDownList.defaultAlign': function (v) { this.defaultAlign = v; },
        'item.dropDownList.isRequired': function (v) { this.isRequired = v; },
        'item.dropDownList.altLabel': function (v) { this.altLabel = v; },
        'item.dropDownList.items': function (v) { this.items = v || []; },
        'item.visibility': function (v) { this.visibility = v; },
        'item.slug': function (v) { this.slug = v || ''; },
    },
};
</script>

<style lang="scss" scoped>
#dropdown-list-settings {
    padding: 8px 12px 24px 12px;

    .form-field {
        display: flex;
        flex-direction: column;
        margin-bottom: 16px;

        .form-label {
            margin-bottom: 6px;
            font-weight: 600;
            color: #374151;
            font-size: 0.875rem;
            letter-spacing: 0.025em;
        }

        .form-input {
            padding: 8px 12px;
            border: 1px solid #d1d5db;
            border-radius: 8px;
            background-color: #ffffff;
            color: #374151;
            font-size: 0.875rem;
            transition: border-color 0.2s ease, box-shadow 0.2s ease;

            &:focus {
                outline: none;
                border-color: #f26a52;
                box-shadow: 0 0 0 3px rgba(242, 106, 82, 0.1);
            }

            &::placeholder {
                color: #9ca3af;
            }
        }

        .button-group {
            display: flex;
            gap: 4px;
            margin-bottom: 8px;

            .button {
                flex: 1;
                padding: 6px 8px;
                border: 1px solid #e5e7eb;
                border-radius: 6px;
                background-color: #f9fafb;
                color: #6b7280;
                font-size: 0.8rem;
                font-weight: 500;
                cursor: pointer;
                text-align: center;
                transition: all 0.2s ease;

                &.active {
                    background-color: #f26a52;
                    color: #ffffff;
                    border-color: #f26a52;
                    box-shadow: 0 1px 3px rgba(242, 106, 82, 0.3);
                }

                &:hover:not(.active) {
                    background-color: #f3f4f6;
                    border-color: #d1d5db;
                }
            }
        }

        .form-description {
            margin-top: 4px;
            font-size: 0.75rem;
            color: #9ca3af;
            line-height: 1.3;
        }

        .toggle {
            display: flex;
            align-items: center;

            .toggle-option {
                padding: 8px 16px;
                border: 1px solid #e5e7eb;
                border-radius: 6px;
                background-color: #f9fafb;
                color: #6b7280;
                font-size: 0.8rem;
                font-weight: 500;
                cursor: pointer;
                text-align: center;
                transition: all 0.2s ease;
                min-width: 80px;

                &.active {
                    background-color: #10b981;
                    color: #ffffff;
                    border-color: #10b981;
                    box-shadow: 0 1px 3px rgba(16, 185, 129, 0.3);
                }

                &:hover:not(.active) {
                    background-color: #f3f4f6;
                    border-color: #d1d5db;
                }
            }
        }
    }
}
</style>
